<script>
	import AOT from "/vite/Icon.svelte";
	const rest = $props();
	const vars = {"attributes":{"viewBox":"0 0 12 12","fill":"none"},"iconId":"svg-2","raw":"<path d=\"M4.49977 3.35538C4.30477 3.55038 4.30477 3.86538 4.49977 4.06038L6.43977 6.00038L4.49977 7.94038C4.30477 8.13538 4.30477 8.45038 4.49977 8.64538C4.69477 8.84038 5.00977 8.84038 5.20477 8.64538L7.49977 6.35038C7.69477 6.15538 7.69477 5.84038 7.49977 5.64538L5.20477 3.35038C5.01477 3.16038 4.69477 3.16038 4.49977 3.35538Z\" fill=\"currentColor\"></path>"};
</script>

<AOT {...rest} {vars} />